<script type="text/javascript">
import { Bar, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;
export default {
  name: 'BarChart',

  extends: Bar,

  mixins: [reactiveProp],

  props: {
    options: {
      type: Object,
      default: function() {
        return { responsive: true, maintainAspectRatio: false };
      },
    },
  },

  mounted() {
    this.renderChart(this.chartData, this.options);
  },
};
</script>
